/**
 * Shared task actions component
 * Used by all task templates for consistent action buttons
 *
 * @module pages/tasks/components/templates/TaskActions
 */

import { Link } from 'react-router-dom';
import { Button } from '@/components/atoms/Button';
import type { TaskTemplateProps } from '../../types';

type TaskActionsProps = Omit<TaskTemplateProps, 'debugMode'>;

export function TaskActions({ task, onNavigate, onComplete, onDismiss, onDelete, isUpdating }: TaskActionsProps) {
  return (
    <div className="flex flex-col gap-2 flex-shrink-0">
      {/* Navigate to target */}
      <Link
        to={task.targetUrl}
        onClick={onNavigate}
        className="px-3 py-1.5 text-sm font-medium text-primary bg-primary/10 hover:bg-primary/20 rounded transition-colors text-center"
      >
        Go to Task
      </Link>

      {/* Status actions for pending tasks */}
      {task.status === 'pending' && (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={onComplete}
            disabled={isUpdating}
          >
            Complete
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
            disabled={isUpdating}
          >
            Dismiss
          </Button>
        </>
      )}

      {/* Delete for manual tasks */}
      {task.sourceType === 'manual' && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onDelete}
          disabled={isUpdating}
          className="text-danger hover:text-danger"
        >
          Delete
        </Button>
      )}
    </div>
  );
}
